import Axios from 'axios';

// The Envoy Gateway rejects request bodies over 100MB with a 413. When that response lacks CORS
// headers the browser reports it as a network error with no response, which looks the same as a
// timeout or dropped connection, so that case gets a message that doesn't assume the cause.
export const UPLOAD_TOO_LARGE_MESSAGE = 'File size exceeds 100MB limit';
export const UPLOAD_INTERRUPTED_MESSAGE =
  'Upload failed. The file may exceed the 100MB limit, or the connection was interrupted.';

export const getUploadErrorMessage = (error, hasFiles) => {
  if (Axios.isCancel(error)) {
    return null;
  }
  if (error?.response?.status === 413) {
    return UPLOAD_TOO_LARGE_MESSAGE;
  }
  if (!error?.response && hasFiles) {
    return UPLOAD_INTERRUPTED_MESSAGE;
  }
  return null;
};
